import React from 'react'; 
import PropTypes from 'prop-types';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import FortisButton from '../Basic/FortisButton';
import LinkButton from '../Basic/LinkButton';

const StepNavButtons = ({text, onNextClick, onBackClick, onCancelClick,isShowSave , onSaveClick, error}) => {
  return (
    <div className="form-group">
      <ButtonToolbar style={{display: "inline-flex"}}>
        <LinkButton text="Back" onClick={onBackClick} />
        <FortisButton text={text} onClick={onNextClick} />
        {
          isShowSave ?
             <LinkButton text="Save this request and submit it later" onClick={onSaveClick} />
             : null
        }
        <LinkButton text="Cancel" onClick={onCancelClick} />
      </ButtonToolbar>
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
};

StepNavButtons.propTypes = {
  text: PropTypes.string.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isShowSave : PropTypes.bool,
  onSaveClick : PropTypes.func,
  error: PropTypes.string
};

export default StepNavButtons;


